import gql from 'graphql-tag';

export default gql`
  query province2507Search($regions: [String], $pagination: Pagination!, $provinceCodes: [String], $orderBy: [OrderBy]) {
    province2507Search(regions: $regions, pagination: $pagination, provinceCodes: $provinceCodes, orderBy: $orderBy) {
      total
      data {
        code
        name
        nameEn
        fullName
        fullNameEn
      }
    }
  }
`;
